/* eslint-disable block-scoped-var */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
export class keyManager {
    constructor() {

    }

    createKey(scene, keychoosed) {
        return scene.input.keyboard.addKey(keychoosed);
    }
    AssignGameKeys(scene) {
        scene.keyW = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.UP);
        scene.keyS = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.DOWN);
        scene.keyA = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.LEFT);
        scene.keyD = this.createKey(scene,
            Phaser.Input.Keyboard.KeyCodes.RIGHT
        );
        scene.keySpace = this.createKey(scene,
            Phaser.Input.Keyboard.KeyCodes.SPACE
        );
        scene.keyz = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.Z);
        scene.keyx = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.X);
        scene.keyc = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.C);
        scene.keyv = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.V);
        scene.keyshift = this.createKey(scene,
            Phaser.Input.Keyboard.KeyCodes.SHIFT
        );
        scene.keyctrl = this.createKey(scene,
            Phaser.Input.Keyboard.KeyCodes.CTRL
        );
        scene.keyS = this.createKey(scene, Phaser.Input.Keyboard.KeyCodes.S);
    }


}